import { intercepter, mock } from '../config';

mock.mock(/\/auth\/logout\/mock*/, 'post', intercepter(null, null));
